module.exports = __webpack_public_path__ + "img/sq5d_04.67919ae6.jpg";